import { OpenIcon } from '@/assets/icons/open-icon'
import { Button } from '@/components/ui/button'

interface OpenAcademicTranscriptProps {
  link: string
  disabled?: boolean
}

export const OpenAcademicTranscript = ({
  link,
  disabled
}: OpenAcademicTranscriptProps) => {
  const openInNewTab = () => {
    window.open(link, '_blank', 'noopener,noreferrer')
  }

  return (
    <Button
      onClick={openInNewTab}
      type="button"
      variant={'light'}
      disabled={disabled}
      aria-label="Abrir histórico do aluno em nova aba"
    >
      <div className="flex gap-2 items-center">
        <p>Histórico Escolar</p>
        <OpenIcon />
      </div>
    </Button>
  )
}
